import sessionApi, { PaginatedResult, paginatedResult } from './apiClient';
import { Notification } from '../types/domain';

export interface SystemNotificationFilters {
  status?: 'unread' | 'read' | 'dismissed' | string;
  severity?: string;
  notification_type?: string;
  category?: string;
  search?: string;
  officer?: number;
  admin_department?: number;
  page?: number;
}

const fetchSystemNotificationPage = async (
  filters: SystemNotificationFilters = {}
): Promise<PaginatedResult<Notification>> => {
  const response = await sessionApi.get('/system-notifications/', { params: filters });
  return paginatedResult<Notification>(response.data);
};

export const notificationService = {
  getSystemNotificationsPage: fetchSystemNotificationPage,

  getSystemNotifications: async (
    filters: SystemNotificationFilters = {}
  ): Promise<Notification[]> => {
    const page = await fetchSystemNotificationPage(filters);
    return page.results;
  },

  generateLtopfNotifications: async (_warningDays?: number) => {
    const response = await sessionApi.post('/system-notifications/generate-compliance/');
    return response.data;
  },

  markNotificationRead: async (id: number) => {
    const response = await sessionApi.post(`/system-notifications/${id}/mark-read/`);
    return response.data;
  },

  dismissNotification: async (id: number) => {
    const response = await sessionApi.post(`/system-notifications/${id}/dismiss/`);
    return response.data;
  },
};
